<template>
  <div class="mt-4">
    <div v-if="cargando" class="spinner">Cargando...</div> <!-- Indicador de carga -->
    <ResumenTareas v-else :costoTotalTareasDolares="costoTotalTareasDolares" :horasTotalTareas="horasTotalTareas"
      :totalTareas="totalTareas" />
    <BuscadorTareas v-model:busquedaTareas="busquedaTareas" />
    <ListaTareasSemana :semanasColapsadas="semanasColapsadas" @update:semanasColapsadas="semanasColapsadas = $event"
      @eliminar="eliminarTarea" :tareasPorSemanaFiltradas="tareasPorSemanaFiltradas" />

  </div>
</template>

<script>
import ResumenTareas from './ResumenTareas.vue';
import BuscadorTareas from './BuscadorTareas.vue';
import ListaTareasSemana from './ListaTareasSemana.vue';
import axios from '@/axios';



export default {
  components: {
    ResumenTareas,
    BuscadorTareas,
    ListaTareasSemana,
  },
  props: {
    proyecto_evento_id: Number,
  },
  data() {
    return {
      busquedaTareas: '', // La búsqueda usada para filtrar tareas
      tareasPorSemana: {}, // Datos agrupados por semana
      tareas: [], // Todas las tareas
      semanasColapsadas: [], // Asegúrate de que esté inicializado como un array vacío
      cargando: false, // Estado de carga
    };
  },
  computed: {
    tareasPorSemanaFiltradas() {
      if (!this.busquedaTareas) return this.tareasPorSemana;

      const filtro = this.busquedaTareas.toLowerCase();
      const filtradas = {};

      Object.keys(this.tareasPorSemana).forEach(semana => {

        const tareas = this.tareasPorSemana[semana].filter(tarea => 
          tarea.nombre_tarea.nombre.toLowerCase().includes(filtro) ||
          tarea.objeto.nombre.toLowerCase().includes(filtro) ||
          tarea.personal.some(personal =>
            personal.personal.nombre.toLowerCase().includes(filtro) ||
            personal.personal.apellido.toLowerCase().includes(filtro) ||
            personal.personal.legajo.toLowerCase().includes(filtro)
          ) ||
          tarea.tarea_usa_items.some(item =>
            item.inventario_item.nombre.toLowerCase().includes(filtro) 
          ) 
        ) ;
        if (tareas.length > 0) {
          filtradas[semana] = tareas;
        }
      });

      return filtradas;
    },
    totalTareas() {
      if (!this.tareas) return 0;
      return this.tareas.length;
    },
    horasTotalTareas() {
      if (!this.tareas) return 0;
      if (this.tareas.length === 0) return 0;
      return this.tareas.reduce((total, tarea) => total + tarea.duracion_horas, 0);
    },
    costoTotalTareasDolares() {
      if (!this.tareas) return 0;
      if (this.tareas.length === 0) return 0;
      return this.tareas.reduce((total, tarea) => total + tarea.costo_final_usd, 0);
    },
  },

  created() {
    this.obtenerTareas();
  },
  methods: {
    obtenerTareas() {
      this.cargando = true; // Inicia la carga
      axios.get(`/api/tareasPorProyectoEvento/${this.proyecto_evento_id}`)
        .then(response => {
          this.tareas = response.data;

          this.agruparTareasPorSemana();
        })
        .catch(error => {
          console.error('Error al cargar tareas:', error);
        })
        .finally(() => {
          this.cargando = false; // Finaliza la carga
        });


    },
    agruparTareasPorSemana() {
      const agrupadas = {};
      this.tareas.forEach(tarea => {



        const fechaTarea = new Date(tarea.fecha_creacion);
        const fechaInicioEvento = new Date(tarea.proyecto_evento.fecha_inicio);
        const semana = this.obtenerNumeroSemana(fechaTarea, fechaInicioEvento);
        if (!agrupadas[semana]) {
          agrupadas[semana] = [];
        }
        agrupadas[semana].push(tarea);
      });
      this.tareasPorSemana = agrupadas;
    },

    //dada una fecha actual y una fecha de inicio de semana, devuelve el número de semana
    obtenerNumeroSemana(fechaActual, fechaInicioSemana) {
      // Establecer las horas, minutos, segundos y milisegundos a cero
      fechaActual.setHours(0, 0, 0, 0);
      fechaInicioSemana.setHours(0, 0, 0, 0);

      const diferencia = fechaActual - fechaInicioSemana;
      const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
      return Math.floor(dias / 7) + 1; // Asegura que la semana comience en 1
    },

    eliminarTarea(tareaId) {

      //armar un string con la informacion de los items a eliminar
      const tarea = this.tareas.find(t => t.id === tareaId);

      
      const items = tarea.tarea_usa_items.map(item => `${item.cantidad} ${item.inventario_item.unidad_de_medida} ${item.inventario_item.nombre}`).join(', ');

      //mensaje de confirmacion con los items a eliminar
      const confirmacion = confirm(`¿Estás seguro de eliminar la tarea? Se agregaran al Stock del Inventario los siguientes items: ${items}`);

      if (!confirmacion) return;

      axios.delete(`/api/tareas/${tareaId}`)
        .then(() => {
          this.obtenerTareas();
        })
        .catch(error => {
          console.error('Error al eliminar tarea:', error);
        });
    },

  }
};

</script>
